import ResetPasswordForm from '@/components/forms/ResetPasswordForm';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { getRedirectRoute } from '@/utils/redirect';
import { getPendingTenantSelectionFlag, clearPendingTenantSelectionFlag } from '@/utils/loginFlow';
import AuthPageShell from '@/components/auth/AuthPageShell';
import { useTranslation } from 'react-i18next';

type ResetPasswordSearch = {
  token?: string;
};

export const Route = createFileRoute('/reset-password')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): ResetPasswordSearch => ({
    token: (search.token as string) || undefined
  }),
  beforeLoad: ({ context }) => {
    if (!context?.auth) clearPendingTenantSelectionFlag();
    if (context?.auth && !getPendingTenantSelectionFlag()) {
      throw redirect({ to: getRedirectRoute(context.auth) });
    }
  }
});

function RouteComponent() {
  const { token: resetToken } = Route.useSearch();
  const { t } = useTranslation(['auth', 'common']);

  return (
    <AuthPageShell
      title={t('auth:resetPassword.title')}
      subtitle={t('auth:resetPassword.subtitle')}
    >
      <ResetPasswordForm token={resetToken} />
    </AuthPageShell>
  );
}
